import { api } from '@marine/api-client/api';
import type { Tenant, TenantCreateInput, TenantUser } from '../types/platform.types';
import type { PaginatedResponse } from '@marine/api-client/types/api';

export interface TenantFilters {
  search?: string;
  status?: string;
  subscription_plan?: string;
  business_type?: string;
  sort_by?: string;
  sort_order?: 'asc' | 'desc';
  page?: number;
  per_page?: number;
}

export interface TenantUsersFilters {
  page?: number;
  per_page?: number;
  search?: string;
  role?: string;
  status?: string;
}

export const tenantsApi = {
  getAll: (filters?: TenantFilters): Promise<PaginatedResponse<Tenant>> =>
    api.getPaginated<Tenant>('/api/tenants', { params: filters }),

  getById: (id: string): Promise<Tenant> =>
    api.getOne<Tenant>(`/api/tenants/${id}`),

  create: (tenantData: TenantCreateInput): Promise<Tenant> =>
    api.postOne<Tenant>('/api/tenants', tenantData),

  update: (id: string, tenantData: Partial<Tenant>): Promise<Tenant> =>
    api.patchOne<Tenant>(`/api/tenants/${id}`, tenantData),

  delete: (id: string): Promise<string> =>
    api.deleteOne(`/api/tenants/${id}`),

  activate: (id: string): Promise<Tenant> =>
    api.postOne<Tenant>(`/api/tenants/${id}/activate`),

  suspend: (id: string, reason: string): Promise<Tenant> =>
    api.postOne<Tenant>(`/api/tenants/${id}/suspend`, { reason }),

  getTenantUsers: (id: string, filters?: TenantUsersFilters): Promise<PaginatedResponse<TenantUser>> =>
    api.getPaginated<TenantUser>(`/api/tenants/${id}/users`, { params: filters }),
};
